module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/data-bg.26d489ce.png";